import React from 'react'

export default class Footer extends React.Component {
	render() {
		return (
			<footer>
				<div className="float-left">
					{hp.store.footer.category}
				</div>
				<div className="float-right" dangerouslySetInnerHTML={{__html: hp.store.footer.body}} />
				<div className="clearfix" />
			</footer>
		);
	}
}
